import { ENV_VARS } from './constants';

export type Environment = {
	[varName in ENV_VARS]: string;
};

function normalizeEnvUrl(url?: string): string {
	return (url || '').trim().replace(/\/+$/, '');
}

function processEnvToConfig(env: NodeJS.ProcessEnv): Readonly<Environment> {
	return {
		HACKETT_ADVISORY_BASE_URL: normalizeEnvUrl(env.REACT_APP_HACKETT_ADVISORY_BASE_URL),
		HACKETT_ADVISORY_SHOW_DEBUG: env.REACT_APP_HACKETT_ADVISORY_SHOW_DEBUG || '',
		HACKETT_ADVISORY_USE_REAL_AUTH: env.REACT_APP_HACKETT_ADVISORY_USE_REAL_AUTH || '',
		HACKETT_ADVISORY_AUTH_UI_URL: normalizeEnvUrl(env.REACT_APP_HACKETT_ADVISORY_AUTH_UI_URL),
		HACKETT_ADVISORY_COOKIE_DOMAIN: env.REACT_APP_HACKETT_ADVISORY_COOKIE_DOMAIN || 'localhost',
		HACKETT_ADVISORY_GOOGLE_ANALYTICS_ID: env.REACT_APP_HACKETT_ADVISORY_GOOGLE_ANALYTICS_ID || '',
		HACKETT_ADVISORY_TOOLS_ORIGIN: normalizeEnvUrl(env.REACT_APP_HACKETT_ADVISORY_TOOLS_ORIGIN),
		SENTRY_DSN: env.REACT_APP_SENTRY_DSN || '',
		HACKETT_ADVISORY_PACKAGE_VERSION: env.HACKETT_ADVISORY_PACKAGE_VERSION || ''
	};
}

export function getEnvConfig(): Readonly<Environment> {
	return processEnvToConfig(process.env);
}
